/**
 * event-gateway.js
 * Submits Event mode requests through fetch/FormData.
 */

import { resolveFetch, submitFormRequest } from './form-submit.js';

function inferApiBase() {
  if (typeof window === 'undefined') {
    return 'http://localhost:3001';
  }
  const host = window.location && window.location.hostname ? window.location.hostname : 'localhost';
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  return isLocal ? 'http://' + host + ':3001' : 'https://api.agilepro.ai';
}

function normaliseAttachments(list = []) {
  if (!Array.isArray(list)) {
    return list ? [list] : [];
  }
  return list.filter((file) => file != null);
}

export class EventGateway {
  constructor({ fetch, apiBase = null } = {}) {
    const fetchImpl = resolveFetch(fetch);
    if (!fetchImpl) {
      throw new Error('EventGateway requires a fetch implementation');
    }
    this.fetch = fetchImpl;
    this.apiBase = apiBase || inferApiBase();
  }

  async submitPlan({
    persona,
    lens,
    teamId,
    scopeId = null,
    teamName,
    eventType,
    timebox,
    notes,
    precisionMessage,
    attachments = [],
    useIntelligenceContext = false,
  }) {
    return submitFormRequest({
      fetch: this.fetch,
      url: this.apiBase + '/api/event',
      fields: {
        persona,
        lens,
        teamId,
        scopeId: scopeId || '',
        team: teamName || '',
        event: eventType,
        timebox,
        notes,
        precisionMessage,
        // Spec 010: off unless the facilitator turned it on.
        useIntelligenceContext: useIntelligenceContext === true ? 'true' : 'false',
      },
      files: normaliseAttachments(attachments),
    });
  }

  async submitFollowup({
    persona,
    lens,
    teamId,
    scopeId = null,
    teamName,
    followupMessage,
    originalMessage,
    eventContext = {},
    attachments = [],
    useIntelligenceContext = false,
  }) {
    return submitFormRequest({
      fetch: this.fetch,
      url: this.apiBase + '/api/coach',
      fields: {
        persona,
        lens,
        teamId,
        scopeId: scopeId || '',
        team: teamName || '',
        message: followupMessage,
        originalMessage,
        notes: eventContext.notes || '',
        _mode: 'event-followup',
        _event: eventContext.event || null,
        _timebox: eventContext.timebox || null,
        useIntelligenceContext: useIntelligenceContext === true ? 'true' : 'false',
      },
      files: normaliseAttachments(attachments),
    });
  }
}

if (typeof window !== 'undefined') {
  window.AgileProGateways = window.AgileProGateways || {};
  window.AgileProGateways.EventGateway = EventGateway;
}
